/**
 * Short-form scheduled date formatter (FR-024 REPLACED 2026-05-01).
 *
 * Formats a parseable ISO date as `M/d/yyyy` in en-US (no leading zeros, no
 * day-of-week, no month name) — e.g., `2026-06-16` → `6/16/2026`. Returns
 * `null` (NOT the sentinel string `"-"`) for null / undefined / empty /
 * whitespace-only / malformed input so the calling row can collapse cleanly
 * per FR-022 / FR-028.
 *
 * `Intl.DateTimeFormat({ month: "numeric", day: "numeric" })` is intentionally
 * NOT used because the en-US default may add leading zeros on some platforms;
 * direct `Date` accessors guarantee the requested format.
 */
export function formatScheduledShortDate(
	dateString: string | null | undefined,
): string | null {
	if (!dateString || dateString.trim().length === 0) {
		return null;
	}

	const date = new Date(dateString);
	if (Number.isNaN(date.getTime())) {
		return null;
	}

	const month = date.getMonth() + 1;
	const day = date.getDate();
	const year = date.getFullYear();

	return `${String(month)}/${String(day)}/${String(year)}`;
}
